import script from "./index.vue?vue&type=script&lang=ts&name=layout-toolbar&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&name=layout-toolbar&setup=true"

import "./index.vue?vue&type=style&index=0&id=c37849d2&lang=scss"

const __exports__ = script;

export default __exports__